import React from 'react';
import { filterResource as filter } from '../../functions/filterResource';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import './Iterate.css';

const childrenWithResource = ({ on, resource, children }) => {
  let values = filter(resource, on);
  if (!Array.isArray(values)) {
    values = [values];
  }

  return values.map((v, i) => React.cloneElement(React.Children.only(children), { resource: v, key: i }));
};

const Iterate = (props, context) => (
  <div className="Iterate">
    <div className="output-label">{getLabel(context.locale, props.label)}</div>
    {childrenWithResource(props)}
  </div>
);

Iterate.contextTypes = {
  locale: PropTypes.string,
};

export default Iterate;



// WEBPACK FOOTER //
// ./src/main/components/container/Iterate.js